export default {
  KP_TABBAR_HEIGHT: 100, // tabbar高度, 基础值为100px,在使用的时候需要转成 px2rem
}

export enum OpenSource {
  APP = '0',
  SHELL = '1',
}

// app的env映射
export const APP_ENV_MAP: { [key: string]: string } = {
  debug: 'development',
  _test: 'testing',
  release: 'production',
}

// 集群列表
export const CLUSTER_LIST = ['/g1', '/c1', '/c2']